var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.checkingNum > 0
    ? _c(
        "div",
        { staticClass: "pa-3" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "pt-0", staticStyle: { display: "flex" } },
                [
                  _c("v-flex", { attrs: { xs3: "" } }, [
                    _c(
                      "div",
                      { staticClass: "top_20" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mouse",
                            attrs: { fab: "", large: "", color: _vm.color },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(_vm.routerLink)
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { large: "" } }, [
                              _vm._v(_vm._s(_vm.icon)),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs9: "", "pr-3": "" } }, [
                    _c("div", [
                      _c("div", {
                        staticClass: "body-1 card_text_right text_grey",
                        domProps: { innerHTML: _vm._s(_vm.checkingMessage) },
                      }),
                      _vm._v(" "),
                      _vm.checkingArr
                        ? _c(
                            "div",
                            { staticClass: "body-1 card_text_right text_grey" },
                            [
                              _c(
                                "div",
                                { staticStyle: { overflow: "hidden" } },
                                _vm._l(_vm.checkingArr, function (col, index) {
                                  return _c(
                                    "ul",
                                    { key: index, staticClass: "ul_style" },
                                    _vm._l(col, function (row, index) {
                                      return _c(
                                        "li",
                                        { key: index, staticClass: "li_style" },
                                        [_vm._v(_vm._s(row))]
                                      )
                                    }),
                                    0
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "display-1 card_text_right" }, [
                        _vm._v(_vm._s(_vm.checkingNum)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.routerLink
                ? [
                    _c("v-divider"),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c(
                          "v-btn",
                          { attrs: { small: "", to: _vm.routerLink } },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { color: "info" } },
                              [_vm._v("build")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-none" }, [
                              _vm._v("Fix"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }